// import type { PostMessageData } from '@/types';

export const useCmsStore = defineStore('cmsStore', () => {
  const cmsReady = ref<boolean>(false);
  const cmsMode = ref<boolean>(false);

  async function init() {
    if (!cmsReady.value) {
      cmsMode.value = window ? window.location !== window.parent.location : false;
      await $fetch('/api/auth/cms-login');

      // if (cmsMode.value) {
      //   window.addEventListener('message', onReceivePostMessage);
      // }

      cmsReady.value = true;
    }
  }

  //CMS Asset
  // async function fetchAssetBySlug<T>(slug: string) {
  //   const {data, error} = await useLazyFetch(`/api/asset-by-slug?slug=${slug}&status=${window ? (window.location !== window.parent.location ? 'draft' : 'published') : 'published'}`);
  //   console.log('fetchAssetBySlug', slug, data, error);
  //   // console.log('resp', data, 'api error', error);
  //   return error.value ? {error: error} : (data.value as T);
  // }

  // function onReceivePostMessage(message: MessageEvent) {
  //   console.log('onReceivePostMessage from parent', message);
  // }

  // function sendPostMessage(data) {
  //   if (cmsMode.value) {
  //     console.log('sendMessageToIframe');
  //     window.parent.postMessage(JSON.stringify(data), 'http://localhost:7001');
  //   }
  // }

  return {
    cmsReady,
    cmsMode,
    init,
    // fetchAssetBySlug,
    // sendPostMessage,
  };
});
